var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"error-page"}},[_c('h1',[_vm._v("システム障害が発生しております。。")]),_c('h2',[_vm._v("復旧するまでお待ちください。")]),_c('pre',[_c('i',{domProps:{"textContent":_vm._s(_vm.errorMessage)}})])])}
var staticRenderFns = []

export { render, staticRenderFns }